import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import SolidExclamationCircleIcon from 'components/Luxkit/Icons/solid/SolidExclamationCircleIcon'
import Caption from 'components/Luxkit/Typography/Caption'

export const PricingWrapper = styled.div`
  display: flex;
`

export const Root = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: ${rem(16)};
`

export const CacheOffText = styled(Caption)`
  margin-top: ${rem(8)};
  white-space: normal;
  min-height: ${rem(90)};

  &.short {
    min-height: ${rem(70)};
  }

  &.infobar {
    max-width: ${rem(145)}
  }
`

export const PriceContainer = styled.div`
  line-height: 1.25;
  white-space: nowrap;

  &.cache-off {
    width: 50%
  }

  & + & {
    border-left: 1px solid ${props => props.theme.palette.neutral.default.five};
    margin-left: ${rem(16)};
    padding-left: ${rem(16)};
  }
`

export const HiddenBlock = styled.div`
  display: none;
`

export const PriceWrapper = styled.div`
  flex-direction: column;
  align-items: flex-start;
`

export const StyledExclamationIcon = styled(SolidExclamationCircleIcon)`
  position: relative;
  margin-left: ${rem(5)};
  top: ${rem(3)};
`

export const ValueWrapper = styled(Caption)`
  display: flex;
  gap: ${rem(4)};
  flex-wrap: wrap;
  align-items: center;
`

export const SingleValueWrapper = styled(Caption)`
  display: flex;
  margin-left: ${rem(12)};
  margin-top: ${rem(8)};

  ${mediaQueryUp.desktop} {
    display: none;
  }
`

export const CruiseSingleValueWrapper = styled(Caption)`
  display: flex;
  margin-left: ${rem(12)};
  margin-top: ${rem(8)};
`
